import { isDevelopment } from "~/Common/Environment";

if (!isDevelopment()) {
	console.debug = function () {
		/* noop */
	};
}
